module.exports = __webpack_public_path__ + "static/media/aliExpress_icon.8a8de45e.jpg";